import { SelfPublishesStore } from '.';

export const selectSelfPublishState = (store: SelfPublishesStore) => store.selfPublishes.selfPublish;
